import entityMapping from '@/lti/store/entityMapping'
import { storeEntities } from '@/lti/store/helpers'

import Vuex from 'vuex'
import Vue from 'vue'

import courses from '@/lti/store/modules/courses'
import eventseries from '@/lti/store/modules/eventseries'
import events from '@/lti/store/modules/events'
import groups from '@/lti/store/modules/groups'
import lecturers from '@/lti/store/modules/lecturers'
import programs from '@/lti/store/modules/programs'
import rps from '@/lti/store/modules/rps'
import lti from '@/lti/store/modules/lti'
import students from '@/lti/store/modules/students'
import users from '@/lti/store/modules/users'
import attendancelist from '@/lti/store/modules/attendancelist'
import studentsevents from '@/lti/store/modules/students/events'
import studentscourses from '@/lti/store/modules/students/courses'
import subscribables from '@/lti/store/modules/students/subscribables'
import advises from '@/lti/store/modules/students/advises'
import questions from '@/lti/store/modules/students/questions'
import downloadlinks from '@/lti/store/modules/downloadlinks'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {},
  mutations: {
    // general entity setter for the store.
    STORE_ENTITIES (state, resources) {
      for (const [key, value] of Object.entries(resources)) {
        if (!(key in entityMapping)) {
          if (key !== 'primaryResources' && key !== 'meta') {
            console.warn(`${key} is an unknown resource key. It is not found in the entityMapping`)
          }
          continue
        }

        storeEntities({
          ...entityMapping[key],
          entities: value,
          storage: entityMapping[key].storage(state),

        })
      }

      return resources
    },
  },
  actions: {},
  getters: {},
  modules: {
    courses,
    events,
    groups,
    lecturers,
    programs,
    rps,
    students,
    users,
    attendancelist,
    studentsevents,
    studentscourses,
    subscribables,
    eventseries,
    questions,
    lti,
    advises,
    downloadlinks,
  },
})
